import React, { useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import s from './TextEditorPage.module.css';
import ReactQuill from 'react-quill';
import { useTheme } from "../../shared/context/ThemeContext";

import {
    selectCurrentProject,
    selectCurrentStep, selectIsBodyPromptVisible, selectIsLoadingScript, selectIsLoadingSharing, selectScriptData
} from "../../store/selectors/projectSelectors";
import PromptBlock from "./widgets/promt-block/PromtBlock";
import WordsCount from "./widgets/words-count/WordsCount";
import 'quill/dist/quill.snow.css';
import './customQuil.css';

import Menu from "../../shared/ui/menu/Menu";
import TextEditorOnboarding from "./widgets/text-editor-onboarding/TextEditorOnboarding";
import ImageUpload from "./widgets/upload-photo/UploadPhoto";

import {useAppDispatch} from "../../store/store";
import {
    fetchProject,
    setCurrentStep,
    setIsPromptBodyVisible,
    shareProjectOnLinkedIn
} from "../../store/slices/projectSlice";
import Loader from "../../shared/ui/loader/Loader";
import {useLocation, useParams} from "react-router-dom";
import {createPortal} from "react-dom";
import Modal from "../../shared/ui/modal/Modal";
import character from '../../assets/img/character.svg'
import {modules} from "./quill/quillConfig";
import {StyledReactQuill} from "./quill/StyledReactQuill";
import PreviewSection from "./widgets/preview-section/PreviewSection";
import PromptSection from "./widgets/prompt-section/PromptSection";

const TextEditorPage: React.FC = () => {
    const quillRef = useRef<ReactQuill | null>(null);
    const { isDarkTheme } = useTheme();
    const scriptData = useSelector(selectScriptData);
    const currentProject = useSelector(selectCurrentProject);
    const isLoadingScript = useSelector(selectIsLoadingScript);
    const isLoadingShare = useSelector(selectIsLoadingSharing);
    const currentStep=useSelector(selectCurrentStep)

    const imageUrl=currentProject?.image?.url||null

    const [value, setValue] = useState<string>('');
    const [imageUploadContainer, setImageUploadContainer] = useState<HTMLElement | null>(null);
    const dispatch = useAppDispatch();
    const {projectId}=useParams();
    const [isPosted, setIsPosted] = useState(false);

    const location = useLocation();
    useEffect(() => {
        const shareProject = async () => {
            const searchParams = new URLSearchParams(location.search);
            const shared = searchParams.get('shared')

            if (shared === 'true' && projectId != null) {
                const result = await dispatch(shareProjectOnLinkedIn({ projectId }));
                if (shareProjectOnLinkedIn.fulfilled.match(result)) {

                    setIsPosted(true)
                    searchParams.delete('shared');
                    const newSearch = searchParams.toString();
                    const newUrl = `${location.pathname}${newSearch ? `?${newSearch}` : ''}`;
                    window.history.replaceState({}, '', newUrl);
                } else if (shareProjectOnLinkedIn.rejected.match(result)) {
                    console.error('Failed to share project:', result.payload);
                }
            }
        };
        shareProject();
    }, []);

    useEffect(() => {
        if(projectId){
          dispatch(fetchProject({ projectId }));
        }
    }, [projectId, dispatch]);

    useEffect(() => {
        if (scriptData) {
            const formattedText = formatScriptData(scriptData);
            setValue(formattedText);


        }
    }, [scriptData]);
    const formatScriptData = (data: typeof scriptData): string => {
        if (!data) return '';
        const formattedBody = data.body.replace(/^<post>\n/, '');
        return formattedBody.replace(/\n\n/g, '<br><br>').replace(/\n/g, '<br>');
    };
    const handleSetValue = (value: string) => {
        setValue(value);

    };


    const handleClickText=()=>{
        dispatch(setIsPromptBodyVisible(true))
        if(currentStep===5){
            dispatch(setCurrentStep(currentStep + 1));
        }

    }

    useEffect(() => {
        if (quillRef.current) {
            const editor = quillRef.current.getEditor();
            const editorElement = editor.root;
            const parentContainer = editorElement?.parentElement;

            if (parentContainer) {
                const container = document.createElement('div');
                container.classList.add(s.image_container)
                parentContainer.appendChild(container);
                setImageUploadContainer(container);
            }
        }
    }, []);


    return (

        <div className={`${s.container} ${isDarkTheme ? s.btn_container_dark : s.btn_container_light}`}>
            <Menu />
            {(isLoadingScript||isLoadingShare) && (
                <Loader/>
            )}
            <div
                className={`${s.background} ${isDarkTheme ? s.background_dark : s.background_light}`}
            >
                <div onClick={handleClickText}>
                    <StyledReactQuill
                        ref={quillRef}
                        value={value}
                        onChange={handleSetValue}
                        modules={modules}
                    />

                </div>
                {currentProject!=null &&
                    <>
                        <PromptSection/>
                        <WordsCount value={value} quillRef={quillRef}/>
                        <PreviewSection value={value} imageUrl={imageUrl}/>

                        {imageUploadContainer &&
                            createPortal(
                                <ImageUpload imageUrl={imageUrl} currentProject={currentProject}/>,
                                imageUploadContainer
                            )}
                    </>
                }

                <TextEditorOnboarding/>
                <Modal
                    isOpen={isPosted}
                    onClose={() => setIsPosted(false)}
                    showHeader={false}
                    width={'200px'}
                    background={'#FFDD35'}
                >
                    <div className={s.post_modal}>
                        <img src={character}/>
                        <p> Congratulations!</p>
                        <p>Your post has been posted!</p>
                        <button onClick={() => setIsPosted(false)}>Done</button>
                    </div>

                </Modal>


            </div>
        </div>
    );
};

export default TextEditorPage;
